import { render } from "./BannerPandenHome.vue?vue&type=template&id=6e321caa"
import script from "./BannerPandenHome.vue?vue&type=script&lang=js"
export * from "./BannerPandenHome.vue?vue&type=script&lang=js"

import "./BannerPandenHome.vue?vue&type=style&index=0&id=6e321caa&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__